import { Controller } from '@hotwired/stimulus';

export default class ChartingChatComposerController extends Controller {
  static outlets = ['charting-chat-screenshot'];

  // eslint-disable-next-line class-methods-use-this -- Stimulus action
  submitOnEnter(event) {
    if (event.shiftKey) return;

    event.preventDefault();
    event.target.form?.requestSubmit();
  }

  // eslint-disable-next-line class-methods-use-this -- Stimulus action
  autosize(event) {
    ChartingChatComposerController.#fitToContent(event.target);
  }

  clearInput(event) {
    if (!event.detail?.success) return;

    ChartingChatComposerController.#resetTextarea(event.target.querySelector('textarea'));
    this.chartingChatScreenshotOutlet?.detach();
  }

  static #fitToContent(el) {
    const maxHeight = parseFloat(getComputedStyle(el).maxHeight) || Infinity;
    /* eslint-disable no-param-reassign -- DOM mutation */
    el.style.height = 'auto';
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
    el.style.height = `${el.scrollHeight}px`;
    /* eslint-enable no-param-reassign */
  }

  static #resetTextarea(textarea) {
    if (!textarea) return;

    /* eslint-disable no-param-reassign -- DOM mutation */
    textarea.value = '';
    textarea.style.height = 'auto';
    textarea.style.overflowY = 'hidden';
    /* eslint-enable no-param-reassign */
  }
}
